import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsProxmoxComponent } from './simple-icons-proxmox.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsProxmoxComponent ],
    exports:      [ SimpleIconsProxmoxComponent ],
    bootstrap:    []
})
export class SimpleIconsProxmoxModule {}
